import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable camelcase */
import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useUrlParams, RangePicker } from 'components';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var defaultStart = moment().subtract(1, 'year').format('YYYY-MM-DD');
var defaultEnd = moment().format('YYYY-MM-DD');

var AccountingTabsHeader = function AccountingTabsHeader(_ref) {
  var getData = _ref.getData;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var startDate = urlQueryParams.startDate || defaultStart;
  var endDate = urlQueryParams.endDate || defaultEnd;
  var queryParams = useRef(_objectSpread(_objectSpread({}, urlQueryParams), {}, {
    startDate: startDate,
    endDate: endDate
  }));
  useEffect(function () {
    getData(queryParams.current);
  }, []);

  var handleDateChange = function handleDateChange(_ref2) {
    var startDate = _ref2.startDate,
        endDate = _ref2.endDate;
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      startDate: startDate,
      endDate: endDate
    });
    getData(queryParams.current);
  };

  return ___EmotionJSX("section", {
    css: tableHeaderContainer
  }, ___EmotionJSX("div", {
    style: {
      flex: '0 0 auto'
    }
  }, ___EmotionJSX(RangePicker, {
    startDatePlaceholderText: "\u041E\u0442 \u0434\u0430\u0442\u0430",
    endDatePlaceholderText: "\u0414\u043E \u0434\u0430\u0442\u0430",
    startDate: startDate,
    endDate: endDate,
    onChange: handleDateChange
  })));
};

AccountingTabsHeader.propTypes = {
  getData: PropTypes.func
};
export default AccountingTabsHeader;